var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenHeartDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#00BA7C",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9205 7.14929C17.5784 6.78493 17.1722 6.4959 16.7252 6.2987C16.2782 6.1015 15.799 6 15.3151 6C14.8312 6 14.3521 6.1015 13.905 6.2987C13.458 6.4959 13.0518 6.78493 12.7098 7.14929L11.9998 7.90512L11.2899 7.14929C10.5989 6.41366 9.66172 6.00038 8.68453 6.00038C7.70733 6.00038 6.77016 6.41366 6.07917 7.14929C5.38819 7.88493 5 8.88267 5 9.92302C5 10.9634 5.38819 11.9611 6.07917 12.6967L6.78911 13.4526L11.9998 19L17.2105 13.4526L17.9205 12.6967C18.2627 12.3325 18.5342 11.9001 18.7194 11.4242C18.9047 10.9483 19 10.4382 19 9.92302C19 9.40785 18.9047 8.89774 18.7194 8.42182C18.5342 7.94589 18.2627 7.51348 17.9205 7.14929Z",
    fill: "#EBFFE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHeartDark);
export default __webpack_public_path__ + "static/media/green-heart-dark.2a412a4532b9c55df3ff0224641cc2e0.svg";
export { ForwardRef as ReactComponent };